import React, { useState, useEffect } from 'react';
import { Card, Container, Col, Row } from 'react-bootstrap';
import { EnvelopeAtFill, Instagram, Linkedin } from 'react-bootstrap-icons';
import ContactForm from './contact-form';

const CSAM_EMAIL = "csam.scma@gmail.com"
export default function ContactUs() {
    const [isMounted, didMount] = useState(false)
    const [loading, isLoading] = useState(true)

    useEffect(()=>{
        didMount(true)
    }, [])

    useEffect(()=>{
        if (isMounted) {
            isLoading(false)
        }
    }, [isMounted])

    if (!loading) return(
        <>
            <div className="nasa-featured-news mt-100" style={{ paddingBottom: '2rem' }}>
                <Row className="justify-content-center">
                    <Col xs={12} sm={10} md={8} lg={6}>
                        <Card className="nasa-style-card" style={{ border: 'none', marginBottom: '2rem' }}>
                            <Card.Header style={{
                                background: 'transparent',
                                border: 'none',
                                borderBottom: '1px solid #e6e6e6',
                                padding: '1.5rem 2rem 1rem 2rem',
                                marginBottom: '0'
                            }}>
                                <h2 style={{
                                    fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                                    fontWeight: '700',
                                    color: '#0b3d91',
                                    margin: '0',
                                    letterSpacing: '-0.02em',
                                    lineHeight: '1.2'
                                }}>
                                    Connect With Us
                                </h2>
                            </Card.Header>
                            <Card.Body style={{ padding: '2rem' }}>
                                <div style={{ 
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    gap: '1.5rem',
                                    alignItems: 'center'
                                }}>
                                    <div 
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.75rem',
                                            padding: '1rem',
                                            borderRadius: '8px',
                                            width: '100%',
                                            maxWidth: '400px',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer',
                                            backgroundColor: '#f8f9fa'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#e9ecef';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#f8f9fa';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                        onClick={() => window.open("mailto:" + CSAM_EMAIL)}
                                    >
                                        <EnvelopeAtFill 
                                            size={24} 
                                            style={{ color: '#0b3d91', flexShrink: 0 }} 
                                        />
                                        <div style={{ flex: 1, textAlign: 'left' }}>
                                            <div style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '0.25rem' }}>
                                                Email Administrator
                                            </div>
                                            <div style={{ fontSize: '0.9rem', color: '#6c757d' }}>
                                                {CSAM_EMAIL}
                                            </div>
                                        </div>
                                    </div>

                                    <div 
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.75rem',
                                            padding: '1rem',
                                            borderRadius: '8px',
                                            width: '100%',
                                            maxWidth: '400px',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer',
                                            backgroundColor: '#f8f9fa'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#e9ecef';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#f8f9fa';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                        onClick={() => window.open("https://www.linkedin.com/company/canadian-society-for-aerospace-medicine-student-resident-section-cstars/mycompany/")}
                                    >
                                        <Linkedin 
                                            size={24} 
                                            style={{ color: '#0b3d91', flexShrink: 0 }} 
                                        />
                                        <div style={{ flex: 1, textAlign: 'left' }}>
                                            <div style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '0.25rem' }}>
                                                LinkedIn
                                            </div>
                                            <div style={{ fontSize: '0.9rem', color: '#6c757d' }}>
                                                Follow us on LinkedIn
                                            </div>
                                        </div>
                                    </div>

                                    <div 
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.75rem',
                                            padding: '1rem',
                                            borderRadius: '8px',
                                            width: '100%',
                                            maxWidth: '400px',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer',
                                            backgroundColor: '#f8f9fa'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#e9ecef';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#f8f9fa';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                        onClick={() => window.open("https://www.instagram.com/csam_scma/?hl=en")}
                                    >
                                        <Instagram 
                                            size={24} 
                                            style={{ color: '#0b3d91', flexShrink: 0 }} 
                                        />
                                        <div style={{ flex: 1, textAlign: 'left' }}>
                                            <div style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '0.25rem' }}>
                                                Instagram
                                            </div>
                                            <div style={{ fontSize: '0.9rem', color: '#6c757d' }}>
                                                @csam_scma
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            <ContactForm />
        </>

    )
}